/* Amaxa — сторінка «Відгуки»: фільтр карток за товаром. */
(function () {
  function init(root) {
    var pills = [].slice.call(root.querySelectorAll('.amxr-pill'));
    var cards = [].slice.call(root.querySelectorAll('.amxr-card'));
    if (!pills.length || !cards.length) return;

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        pills.forEach(function (p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');
        var filter = pill.dataset.filter;
        cards.forEach(function (card) {
          card.hidden = !(filter === 'all' || card.dataset.product === filter);
        });
      });
    });
  }

  function boot() {
    var root = document.querySelector('.amxr');
    if (root) init(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
